<template>
  <div class="checkin-page page safe-page">
    <!-- 顶部返回按钮 -->
    <div class="header flex justify-between items-center mb-10px sky-header">
      <div class="back-btn" @click="handleBack">
        <img src="@/assets/images/mine/left.webp" class="w-30px h-30px" />
      </div>
      <div class="title color-#fff text-16px font-900">
        {{ t('checkIn.freeGems') }}
      </div>
      <div class="w-40px h-28px">

      </div>
    </div>
    <!-- 7 日签到卡片 -->
    <div class="checkin-container relative h-277px"
      :class="[![4, 5, 3].includes(userStore.userInfo.role) ? 'vip' : '']">
      <div class="w-100% h-100% absolute box-bg top-0px left-0px bg-#01031B/50 z-1"
        v-if="[4, 5, 3].includes(userStore.userInfo.role)">
        <!-- <img src="@/assets/images/checkInCenter/vip_bg.svg" class="w-100% h-100%" /> -->
      </div>
      <div class="checkin-card absolute  top-20px w-94% h-257px z-2">
        <div class="card-header">
          <img src="@/assets/images/checkInCenter/icon.webp" class="icon" />
          <span class="title">{{ t('checkIn.sevenDayCheckIn') }}</span>
          <img src="@/assets/images/checkInCenter/icon.webp" class="icon" />
        </div>

        <div v-if="[3, 4, 5].includes(userStore.userInfo.role)" class="subtitle color-#AAADC2!">
          {{ t('checkIn.memberExclusive') }} <span class="color-#6580FF">{{ signedCount }}</span> {{ t('checkIn.days')
          }}
        </div>
        <div class="subtitle color-#AAADC2!" v-else>
          {{ t('checkIn.signInTip') }}
        </div>
        <div class="overflow-x-auto pt-10px">
          <div class="days-container">
            <div class="relative text-center" v-for="(day, idx) in days" :key="idx"
              :style="{ animationDelay: `${idx * 0.1}s` }">
              <div v-if="[4].includes(userStore.userInfo.role)">
                <div class="absolute top--10px right--3px plus-icon">
                  <div class="plus-icon-text">
                    Plus+{{ day.extraRewardsForCheckInPlus }}
                  </div>
                </div>
              </div>
              <div v-if="[5].includes(userStore.userInfo.role)">
                <div class="absolute top--10px right--3px ultra-icon">
                  <div class="ultra-icon-box">
                    Ultra+{{ day.extraRewardsForCheckInUltra }}
                  </div>
                </div>
              </div>
              <div class="day-item" :class="{
                checked: day.isGet,
                current: isToday === idx
              }">
                <div class="absolute top-12px flex items-center justify-center" v-if="day.isGet">
                  <img src="@/assets/images/checkInCenter/check.svg" class="w-22px h-22px" />
                </div>
                <div class="gem-icon">
                  <img src="@/assets/images/home/crystal.webp" class="w-20px h-20px" />
                </div>
                <div class="gem-amount">+{{ [3, 4, 5].includes(userStore.userInfo.role) ? day.vipAmount : day.amount }}
                </div>
              </div>
              <div class="relative mt-10px" :style="{ animationDelay: `${(idx * 0.1) + 0.5}s` }">
                <div class="flex items-center justify-center">
                  <div class="w-4px h-4px bg-#7284F7! rounded-full day-item-dot" v-if="day.isGet || isToday === idx">
                  </div>

                  <div class="w-4px h-4px bg-#fff rounded-full day-item-dot" v-else></div>
                </div>
                <div class="progress-fill-item absolute w-38px! top-1.5px right--23px" v-if="idx < days.length - 1"
                  :class="{ 'bg-#7284F7!': day.isGet }" :style="{ animationDelay: `${(idx * 0.1) + 0.7}s` }"></div>
                <div :class="{ 'color-#7284F7': day.isGet || isToday === idx }"
                  class="text-10px color-#fff day-label-text">
                  {{ t('checkIn.day', { num: idx + 1 }) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!hasAllSignedToday">
          <div v-if="isSignedSevenDays" class="btn-checkin">
            <div class="text-12px font-500 text-center mt-10px checkin-btn-r" @click="goToVip">
              {{ t('checkIn.getVip') }}
            </div>
          </div>
          <div v-else>
            <div class="btn-checkin" v-if="isGetToday === 0">
              <!-- <div v-if="[3].includes(userStore.userInfo.role)" class="btn-checkin">
                <div class="text-12px font-500 text-center mt-10px checkin-btn-vip" @click="handleCheckIn(false)">
                  Claim
                </div>
              </div>
              <div v-else-if="[4].includes(userStore.userInfo.role)" class="btn-checkin">
                <div class="text-12px font-500 text-center mt-10px checkin-btn-r-plus" @click="handleCheckIn(true)">
                  <div class="checkin-btn-r-text">
                    Extra {{days.find(day => day.isGet === 0)?.extraRewardsForCheckInPlus + days.find(day => day.isGet
                      === 0)?.vipAmount}} gems
                  </div>
                  <div class="bg-#3D2205 color-#EAB04E plus">
                    <div>
                      Plus
                    </div>
                  </div>
                </div>
              </div>
              -->
              <div v-if="[5].includes(userStore.userInfo.role)" class="btn-checkin">
                <div class="text-12px font-500 text-center mt-10px checkin-btn-r-ultra"
                  @click="handleCheckIn(true, 'ultra')">
                  <div class="checkin-btn-r-text">
                    {{t('checkIn.getGemsCount', {
                      count: (days.find(day => day.isGet ===
                        0)?.extraRewardsForCheckInUltra || 0) + (days.find(day => day.isGet === 0)?.vipAmount || 0) }) }}
                  </div>
                  <div class="ultra">
                    <div class="ultra-box">{{ t('checkIn.ultra') }}</div>
                  </div>
                </div>
              </div>
              <div v-else-if="[4].includes(userStore.userInfo.role)" class="btn-checkin">
                <div class="text-12px font-500 text-center mt-10px checkin-btn-r-plus" @click="handleCheckIn(false)">
                  <div class="checkin-btn-r-text">
                    {{t('checkIn.getGemsCount', {
                      count: (days.find(day => day.isGet === 0)?.extraRewardsForCheckInPlus
                        || 0) + (days.find(day => day.isGet === 0)?.vipAmount || 0) }) }}
                  </div>
                  <div class="bg-#3D2205 color-#EAB04E plus">
                    <div>
                      Plus
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-checkin" v-else>
                <div class="text-12px font-500 text-center mt-10px checkin-btn-l" @click="handleCheckIn(false)">
                  {{t('checkIn.getGemsCount', {
                    count: ![3].includes(userStore.userInfo.role) ? days.find(day =>
                      day.isGet === 0)?.amount : days.find(day => day.isGet === 0)?.vipAmount }) }}
                </div>
                <div class="text-12px font-500 text-center mt-10px checkin-btn-r" @click="handleCheckIn(true)">
                  {{t('checkIn.extraDaily', { count: days.find(day => day.isGet === 0)?.extraRewardsForCheckInUltra })
                  }}
                  <div class="checkin-btn-r-text">
                    <div>{{ t('checkIn.ultra') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="color-#fff text-12px font-500 text-center mt-10px checkin-text" v-else>
              {{ t('checkIn.signedInTip') }}
            </div>
          </div>
        </div>
        <div class="color-#fff text-12px font-500 text-center" v-else>
          {{ t('checkIn.signedInTip') }}
        </div>
      </div>
    </div>

    <!-- 任务列表 -->
    <div class="tasks-section">
      <div class="tasks-header">
        <!-- <img src="@/assets/images/checkInCenter/gift_icon.webp" class="w-20px h-20px" /> -->
        <span class="tasks-title color-#fff mb-15px">{{ t('checkIn.tasks') }}</span>
      </div>
      <!-- <div class="tasks-subtitle color-#01031B text-9px">Complete tasks and gain growth rewards</div> -->

      <div class="task-list">
        <div class="task-item" v-for="(task, idx) in taskList" :key="task.id"
          :style="{ animationDelay: `${(idx * 0.1) + 0.1}s` }">
          <div class="task-icon">
            <img :src="getTaskIcon(task.id)" class="w-24px h-24px" />
          </div>
          <div class="task-content">
            <div class="task-name">{{ task.title }}</div>
            <div class="task-desc">{{ task.process }}/{{ task.condition }}</div>
          </div>
          <div class="task-actions">
            <div class="task-reward">
              <img src="@/assets/images/home/crystal.webp" class="w-14px h-14px" />
              <span>+{{ task.amount }}</span>
            </div>
            <div class="task-btn" v-if="task.process !== task.condition" @click="handleTaskAction(task)">
              {{ t('checkIn.go') }}
            </div>
            <div v-else class="task-btn-receive" @click="handleGetTaskReward(task)"
              :class="task.gotten ? 'active' : ''">
              {{ task.gotten ? t('checkIn.received') : t('checkIn.receive') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppNewUser :amount="amount" :isNewUser="false" v-model:show="showAppNewUser" />
    <FirstChargePopUp v-model:showPopup="showPopupFirstCharge" url="/" />
    <AppOccupySpace height="100px" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { AppOccupySpace } from '@/components/layout'
import AppNewUser from '@/components/feedback/AppNewUser.vue'
import { showLoadingToast, showErrorToast, closeToast } from '@/utils/toast'
import { CheckCenterAPI } from '@/services/checkCenter'
import { useCheckInCenterStore } from '@/stores/checkInCenter'
import { useUserStore } from '@/stores/user'
import { theme } from '@/styles/theme'
import FirstChargePopUp from '@/views/home/com/FirstChargePopUp.vue'
import { useI18n } from 'vue-i18n'
import { useRandomArrayStore } from '@/stores/useRandomArrayStore'
const randomStore = useRandomArrayStore()
import CryptoJS from 'crypto-js'
import { getFirst32 } from '@/utils/aesCrypto'
const { t } = useI18n()
const days = computed(() => useCheckInCenterStore().days)
const isGetToday = computed(() => useCheckInCenterStore().isGetToday)
const userStore = useUserStore()
const showAppNewUser = ref(false)
const amount = ref(0)
const STORAGE_SIGNED_DATES = 'checkin_signed_dates'
const STORAGE_LAST_RESET = 'checkin_last_reset_week'
const STORAGE_LAST_CHECKIN_DATE = 'checkin_last_date'
const showPopupFirstCharge = ref(false)

// 状态
const signedDates = ref<Set<string>>(new Set())
const lastCheckinTimestamp = ref<number>(0) // 响应式的签到时间戳

/**
 * 检查今天是否可以签到
 * 如果今天已经签到过（存储的日期是今天且在8点之后），则不显示按钮
 */
const canCheckInToday = () => {
  const index = days.value.findLastIndex(day => day.isGet === 1)
  return index === -1 ? 0 : index
}
const isToday = computed(() => {
  const index = days.value.findLastIndex(day => day.isGet === 1)
  return index === -1 ? 0 : index + 1
})
/**
 * 跳转到VIP页面
 */
const goToVip = () => {
  router.push({ name: 'Vip' })
}

const hasAllSignedToday = computed(() => {
  return days.value.every(day => day.isGet === 1)
})
const signedCount = computed(() => {
  // 统计已签到的天数（isGet 为 true）
  return days.value.filter(day => day.isGet).length
})
const progressPercent = computed(() => {
  if (days.value.length === 0) return 0
  // 根据已签到的天数计算百分比
  const checkedDays = days.value.filter(day => day.isGet).length
  return Math.round((checkedDays / days.value.length) * 100)
})

// 任务（简单本地状态占位）
type TaskStatus = 'go' | 'receive' | 'done'
interface TaskItem { id: string; title: string; goal: number; progress: number; amount: number; gotten: boolean }
const router = useRouter()
const taskList = computed(() => useCheckInCenterStore().taskList)


/**
 * 获取当前时间
*/

const getCurrentTime = () => {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}${m}${day}`
}
/**
 * 加载状态
 */
function loadState() {
  // 每周一重置（以 ISO week 计算的简单近似：使用 年-周）
  const now = new Date()
  const firstDayOfYear = new Date(now.getFullYear(), 0, 1)
  const pastDaysOfYear = (Number(now) - Number(firstDayOfYear)) / 86400000
  const week = Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7)
  const weekKey = `${now.getFullYear()}-W${week}`

  const lastReset = localStorage.getItem(STORAGE_LAST_RESET)
  if (lastReset !== weekKey) {
    // 新的一周，重置
    localStorage.setItem(STORAGE_LAST_RESET, weekKey)
    localStorage.removeItem(STORAGE_SIGNED_DATES)
  }

  const raw = localStorage.getItem(STORAGE_SIGNED_DATES)
  if (raw) {
    try {
      const list: string[] = JSON.parse(raw)
      signedDates.value = new Set(list)
    } catch (e) {
      signedDates.value = new Set()
    }
  }
}


/**
 * 任务操作
 */
function handleTaskAction(task: TaskItem) {

  // 去对应页面（占位导航）
  const map: Record<string, string> = {
    1: 'Like',
    2: 'Search',
    3: 'Message',
    4: 'Home'
  }
  const name = map[task.id]
  if (name) router.push({ name })
}

const handleGetTaskReward = async (task: TaskItem) => {
  if (task.gotten) {
    return
  }
  showLoadingToast('Getting reward...')
  await CheckCenterAPI.getTaskReward({
    curDate: Number(getCurrentTime()),
    taskId: task.id
  })

  // 更新用户信息
  await userStore.getUserInfo()
  // 更新任务列表
  useCheckInCenterStore().getCheckInCenterList()
  // 关闭加载提示
  closeToast()

  // 显示新用户弹窗
  amount.value = task.amount
  showAppNewUser.value = true
}

/**
 * 返回
 */
function handleBack() {
  router.back()
}

/**
 * 是否签到满7天
 */
const isSignedSevenDays = computed<boolean>(() => {
  const allGet = days.value.every(day => day.isGet === 1)
  if (allGet) {
    if ([3, 4, 5].includes(userStore.userInfo.role)) {
      return false
    }
    return true
  }
  return false
})

/**
 * 获取任务图标
 */
function getTaskIcon(taskId: string): string {
  const iconMap: Record<string, string> = {
    1: new URL('@/assets/images/checkInCenter/heart.svg', import.meta.url).href,
    2: new URL('@/assets/images/checkInCenter/chat.svg', import.meta.url).href,
    3: new URL('@/assets/images/checkInCenter/message.svg', import.meta.url).href,
    4: new URL('@/assets/images/checkInCenter/level.svg', import.meta.url).href
  }
  return iconMap[taskId] || new URL('@/assets/images/task/default.svg', import.meta.url).href /* @vite-ignore */
}
/**
 * 用户签到
*/
const handleCheckIn = async (isVip?: boolean, vip?: string) => {

  if (isVip) {
    if (![5].includes(userStore.userInfo.role)) {
      router.push({ name: 'Vip', query: { type: 'u', tab: 'chat' } })
      return
    }
  }
  showLoadingToast('Check-in...')

  try {
    await CheckCenterAPI.getUserSignIn({
      userDate: Number(getCurrentTime())
    })

    const isSginIn = days.value.find(item => item.isGet === 0)

    localStorage.setItem('isSginIn', isSginIn.day)

    // 记录签到时间
    const now = new Date().getTime()
    localStorage.setItem(STORAGE_LAST_CHECKIN_DATE, String(now))

    //获取当天时间
    const timestamp = new Date(new Date().toLocaleDateString()).getTime()

    localStorage.setItem('today', String(timestamp))

    await useCheckInCenterStore().getSignInList()

    await userStore.getUserInfo()

    lastCheckinTimestamp.value = now // 更新响应式变量，触发按钮隐藏
    closeToast()
    amount.value = [3].includes(userStore.userInfo.role) ? isSginIn.vipAmount : [4].includes(userStore.userInfo.role) ? isSginIn.extraRewardsForCheckInPlus + isSginIn.vipAmount : [5].includes(userStore.userInfo.role) ? isSginIn.extraRewardsForCheckInUltra + isSginIn.vipAmount : isSginIn.amount
    showAppNewUser.value = true
  } catch (error) {
    showErrorToast("Check-in failed. Please try again")
  }
}
/**
 * 任务列表
*/
onMounted(async () => {
  await useCheckInCenterStore().getCheckInCenterList()
  await useCheckInCenterStore().getSignInList()
  // 初始化时从 localStorage 读取上次签到时间
  const savedTimestamp = localStorage.getItem(STORAGE_LAST_CHECKIN_DATE)
  if (savedTimestamp) {
    lastCheckinTimestamp.value = Number(savedTimestamp)
  }
  loadState()
})


onMounted(() => {
  //支付结果
  // window[randomStore.randomArray[0]] = (e: any) => {
  //   const bytes = CryptoJS.AES.decrypt(e, getFirst32('8e7351e-10cfda-aichat-cherry-ai-ios'))
  //   const json = bytes.toString(CryptoJS.enc.Utf8)
  //   if (JSON.parse(json)[randomStore.randomArray[0]]) {
  //     showPopupFirstCharge.value = false
  //   }
  // }
})
</script>

<style scoped lang="scss">
.checkin-page {
  min-height: 100vh;
  background: #01031B;
  padding: 20px;
  padding-top: 42px;
}

.sky-header {
  position: sticky;
  top: 0px;
  z-index: 99;
  background-color: #01031B;
}

// 顶部返回按钮
.header {

  .back-btn {
    width: 40px;
    height: 40px;
    // background: rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
}

// Gem Rewards 标题区
.rewards-header {
  overflow: hidden;
  width: 100%;
  background-image: url('@/assets/images/checkInCenter/background.webp');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px 20px;
  padding-top: 10px;

  .gift-icon {
    position: absolute;
    bottom: -40px;
    left: 10px;
  }

  .title-wrapper {
    text-align: center;
    margin-top: 90px;
  }

  .balloons {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

// 签到卡片容器
.checkin-container {

  padding: 0 10px;
  border-radius: 20px;

  &.vip {
    background: linear-gradient(180deg, #272F40 0%, #2C2E3F 100%);
  }
}

// 签到卡片
.checkin-card {
  // background: linear-gradient(180deg, #EEF1FF 0%, #FFFFFF 100%);
  border-radius: 20px;
  // padding: 10px;
  // box-shadow: 0 4px 20px rgba(123, 136, 255, 0.15);

  .card-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 8px;

    .icon {
      width: 20px;
      height: 20px;
    }

    .title {
      font-size: 18px;
      font-weight: 800;
      color: #6B7FFF;
    }
  }

  .subtitle {

    text-align: center;
    font-size: 12px;
    color: #9CA3AF;
    margin-bottom: 16px;
    background-image: url('@/assets/images/checkInCenter/title_bg.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    font-weight: 500;
    font-size: 10px;
    padding: 5px 0;
    color: #FFFFFF;
  }

  .days-container {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
    // overflow-x: auto;
    padding: 4px 0;

    .day-item {
      flex-shrink: 0;
      width: 38px;
      height: 65px;
      // border: 1.5px solid #E5E7EB;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;
      transition: all 0.3s ease;
      // background: linear-gradient(180deg, #C9D8FF 0%, #FFFFFF 100%);
      background: rgba(255, 255, 255, 0.1);
      animation: dayItemSlideIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;

      @keyframes dayItemSlideIn {
        0% {
          transform: translateY(20px) scale(0.8);
          opacity: 0;
        }

        100% {
          transform: translateY(0) scale(1);
          opacity: 1;
        }
      }

      opacity: 0.5 !important;


      .absolute-center {
        border-radius: 10px;
        border-color: transparent !important;
      }

      .gem-icon {}

      .gem-amount {
        font-size: 14px;
        font-weight: 700;
        // color: #6B7280;
        color: #C4C7D1;
      }

      .day-label {
        font-size: 10px;
        color: #9CA3AF;
      }

      &.checked {
        // background: linear-gradient(180deg, #7B88FF 0%, #A78BFA 100%);
        border-color: #7B88FF;
        border: 1px solid #3859D8;

        .gem-amount {
          color: #fff;
        }

        .day-label {
          color: rgba(255, 255, 255, 0.8);
        }
      }

      &.current {
        opacity: 1 !important;
        border: 1px solid #7B88FF;
        // background: none;
        // background: linear-gradient(180deg, rgba(90, 104, 255, 0.2) 0%, rgba(149, 165, 255, 0.2) 100%);

        .gem-amount {
          color: #FFFFFF !important;
        }

        // box-shadow: 0 0 0 4px rgba(123, 136, 255, 0.2);
      }
    }
  }

  .progress-section {
    margin-bottom: 16px;
    position: relative;
    width: 130%;
  }

  .progress-bar {
    width: 100%;
    height: 1px;
    // background: #E5E7EB;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 8px;
    position: relative;



    // 进度条上的小圆点
    // &::before {
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   width: 12px;
    //   height: 12px;
    //   background: #7B88FF;
    //   border-radius: 50%;
    //   border: 2px solid #FFFFFF;
    //   z-index: 2;
    // }
  }

  .progress-fill-item {
    background: rgba(255, 255, 255, 0.3);
    width: 38px;
    height: 1px;
  }

  .progress-labels {
    display: flex;
    justify-content: space-between;

    // gap: 8px;


    .progress-label {
      flex-shrink: 0;
      text-align: center;
      font-size: 10px;
      color: #9CA3AF;
      position: relative;
      animation: labelFadeIn 0.4s ease-out both;

      @keyframes labelFadeIn {
        0% {
          transform: translateY(10px);
          opacity: 0;
        }

        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }

  .btn-checkin {
    width: 100%;
    height: 45px;
    display: flex;
    gap: 10px;

    .checkin-btn-l {
      border-radius: 26px;
      border: 1px solid #FFFFFF;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 14px;
      color: #FFFFFF;
    }

    .checkin-btn-r-plus {
      border-radius: 26px;
      // border: 1px solid #FFFFFF;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 14px;
      color: #FFFFFF;
      color: #854A0D;
      background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
      position: relative;

      .plus {
        position: absolute;
        top: -10px;
        font-size: 10px;
        width: 54px;
        height: 16px;
        right: 0px;
        border-radius: 10px 10px 10px 0px;

        div {
          // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
          background: linear-gradient(0deg, #FFDFB3 0%, #EAB04E 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 800;
          font-size: 10px;
          // font-style: italic;
        }
      }
    }

    .checkin-btn-r-ultra {
      background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
      border-radius: 26px;
      // border: 1px solid #FFFFFF;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 14px;
      color: #490D73;
      position: relative;

      .ultra {
        position: absolute;
        top: -10px;
        font-size: 10px;
        width: 54px;
        height: 16px;
        right: 0px;
        border-radius: 10px 10px 10px 0px;
        background: #27053E;

        .ultra-box {
          background: linear-gradient(0deg, #E9D6FF 0%, #A66CFE 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 800;
          font-size: 10px;
        }
      }
    }

    .checkin-btn-vip {
      border-radius: 26px;
      // border: 1px solid #FFFFFF;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 14px;
      color: #0D1D73;
      background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
    }

    .checkin-btn-r {
      flex: 1;
      // background: linear-gradient(270deg, #5A68FF 0%, #95A5FF 100%);
      background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
      border-radius: 26px;
      font-weight: 800;
      font-size: 14px;
      color: #490D73;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .checkin-btn-r-text {
        position: absolute;
        top: -10px;
        right: 0;
        font-size: 12px;
        color: #FFFFFF;
        font-weight: 500;
        // background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
        background: #27053E;
        border-radius: 100px 100px 100px 0px;
        padding: 2px 10px;
        font-weight: 500;
        font-size: 10px;
        color: #854A0D;

        div {
          background: linear-gradient(0deg, #E9D6FF 0%, #A66CFE 100%);
          // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 800;
          // font-size: 12px;
          font-size: 10px;
          // font-style: italic;
        }

      }
    }
  }
}

// 任务区域
.tasks-section {
  padding: 24px 0px;

  .tasks-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 2px;

    .tasks-title {
      font-size: 14px;
      font-weight: 800;
      // color: #374151;
    }
  }

  .tasks-subtitle {
    margin-bottom: 10px;
  }

  .task-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .task-item {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #1B1D32;
    border-radius: 16px;
    padding: 10px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    animation: taskItemSlideIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;

    @keyframes taskItemSlideIn {
      0% {
        transform: translateX(-20px);
        opacity: 0;
      }

      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .task-icon {
      flex-shrink: 0;
      // background: #F3F4F6;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .task-content {
      flex: 1;

      .task-name {
        font-size: 14px;
        font-weight: 700;
        color: #FFFFFF;
        margin-bottom: 4px;
      }

      .task-desc {
        font-size: 12px;
        color: #9CA3AF;
      }
    }

    .task-actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;

      .task-reward {
        display: flex;
        align-items: center;
        gap: 0px;
        font-weight: 900;
        font-size: 12px;
        color: #fff;
        justify-content: center;
      }

      .task-btn-receive {
        width: 71px;
        height: 25px;
        background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
        border-radius: 13px;
        font-weight: 900;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 25px;
        text-align: center;

        &.active {
          opacity: 0.5;
        }
      }

      .task-btn {
        width: 71px;
        height: 25px;
        line-height: 25px;
        border-radius: 13px;
        text-align: center;
        font-weight: 900;
        font-size: 12px;
        background: rgba(114, 132, 247, 0.2);
        border-radius: 13px;
        color: #7284F7;

        &.btn-go {
          // background: #E0E7FF;
          // color: #6366F1;

          &:hover {
            background: #C7D2FE;
          }
        }

        &.btn-receive {
          background: linear-gradient(180deg, #7B88FF 0%, #6366F1 100%);
          color: #FFFFFF;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(123, 136, 255, 0.3);
          }
        }
      }
    }
  }
}

.day-item-dot {
  animation: dotFadeIn 0.4s ease-out both;
  background: rgba(255, 255, 255, 0.2);
}

.day-label-text {
  animation: labelTextFadeIn 0.4s ease-out both;
}

.progress-fill-item {
  animation: progressFillSlide 0.6s ease-out both;
}

@keyframes dotFadeIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes labelTextFadeIn {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes progressFillSlide {
  0% {
    width: 0 !important;
    opacity: 0;
  }

  100% {
    width: 38px !important;
    opacity: 1;
  }
}

.checkin-text {
  color: v-bind('theme.colors.textPrimary');
}

.plus-icon {
  font-weight: 500;
  font-size: 8px;
  color: #EAB04E;
  width: 40px;
  height: 16px;
  background: #01031B;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  .plus-icon-text {
    background: linear-gradient(0deg, #FFDFB3 0%, #EAB04E 100%);
    // background: linear-gradient(0deg, #E9D6FF 0%, #A66CFE 100%);
    // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    // font-weight: 800;
    // font-size: 12px;
    font-size: 8px;
  }
}

.ultra-icon {
  font-weight: 500;
  font-size: 8px;
  color: #A66CFE;
  width: 40px;
  height: 16px;
  background: #01031B;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  .ultra-icon-box {
    // background: linear-gradient(0deg, #FFDFB3 0%, #EAB04E 100%);
    background: linear-gradient(0deg, #E9D6FF 0%, #A66CFE 100%);
    // background: linear-gradient(0deg, #E9D6FF 0%, #A66CFE 100%);
    // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    // font-weight: 800;
    // font-size: 12px;
    font-size: 8px;
  }
}

.box-bg {
  background: linear-gradient(180deg, #272F40 0%, #2C2E3F 100%);
  border-radius: 20px;
}
</style>
